import { useCallback } from 'react';
import { usePostMessage } from '../../context/messageContext';

let newDot;

export const useNewStimulus = () => {
  const postMessage = usePostMessage();
  const getNextStimulus = useCallback(
    ({ dotsForDisplay, seenDots, getSeenDot }) => {
      const getRandomSeenStimulus = () => {
        const repeatedDot = seenDots[Math.floor(Math.random() * seenDots.length)];
        const dotUpdate = { ...repeatedDot, repeat: true };
        return dotUpdate;
      };

      if (getSeenDot) {
        newDot = getRandomSeenStimulus();
        postMessage({ type: 'useVisualFieldReducer', action: 'incrementRepeatedDotCount' });
      } else {
        const randomDotIndex = Math.floor(Math.random() * dotsForDisplay.length);
        newDot = dotsForDisplay[randomDotIndex];
      }

      return { newDot };
    },
    [postMessage],
  );

  return getNextStimulus;
};
